/**
 * Fallback clássico (sem importmap): carrinho e busca continuam
 * funcionando se os módulos Horizon não carregarem.
 */
(function () {
  function cartUrl() {
    if (window.Theme && Theme.routes && Theme.routes.cart_url) return Theme.routes.cart_url;
    return '/cart';
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      var cartBtn = target.closest('[data-testid="cart-drawer-trigger"]');
      if (cartBtn && !customElements.get('cart-drawer-component')) {
        event.preventDefault();
        window.location.href = cartUrl();
        return;
      }

      var searchBtn = target.closest('.andrade-header-search-icon__btn');
      if (searchBtn && !customElements.get('dialog-component')) {
        event.preventDefault();
        window.location.href = '/search';
      }
    },
    true
  );
})();
